import { render, staticRenderFns } from "./PersonnelRecordEmergencyContactsDataTable.vue?vue&type=template&id=35cf3b2f"
import script from "./PersonnelRecordEmergencyContactsDataTable.vue?vue&type=script&lang=js"
export * from "./PersonnelRecordEmergencyContactsDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports